function u(e, n) {
  return e == null ? void 0 : e[n];
}
export {
  u as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_getValue.js
// module id = 1471
// module chunks = 41